/**
 * @description 应用交付 appDelivery
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const appDeliveryBiz = new Logic()

appDeliveryBiz.getAppDeliveryByPage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.getAppDeliveryByPage,
    data: data
  })
}

appDeliveryBiz.saveAppDelivery = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.saveAppDelivery,
    data: data
  })
}

appDeliveryBiz.getDeliveryById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.getDeliveryById,
    data: data
  })
}

appDeliveryBiz.killProcess = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.killProcess,
    data: data
  })
}

appDeliveryBiz.deleteDelivery = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.deleteDelivery,
    data: data
  })
}

appDeliveryBiz.publishDelivery = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.publishDelivery,
    data: data
  })
}

appDeliveryBiz.updateTactics = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.updateTactics,
    data: data
  })
}

appDeliveryBiz.getReleaseHost = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.getReleaseHost,
    data: data
  })
}

appDeliveryBiz.getPublishProgress = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.getPublishProgress,
    data: data
  })
}

appDeliveryBiz.deliveryAbort = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.deliveryAbort,
    data: data
  })
}

appDeliveryBiz.getDeliveryLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.getDeliveryLog,
    data: data
  })
}

appDeliveryBiz.getConfigCheck = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.getConfigCheck,
    data: data
  })
}

appDeliveryBiz.rePublish = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appDelivery.rePublish,
    data: data
  })
}

export default appDeliveryBiz
